
var ColorHelper = {
    convertNumberToRgb(num: number) {
        var r = (num >> 16 & 0xFF);
        var g = (num >> 8 & 0xFF);
        var b = (num >> 0 & 0xFF);

        return { R: r, G: g, B: b };
    },
    convertNumberToArgb(num: number) {
        var r = (num >> 16 & 0xFF);
        var g = (num >> 8 & 0xFF);
        var b = (num >> 0 & 0xFF);
        var a = (num >> 24 & 0xFF) / 255;

        return { R: r, G: g, B: b, A: a };
    },
    convertNumberToHex(num: number) {
        var rbgObj = this.convertNumberToRgb(num);
        return this.convertRgbToHex(rbgObj.R, rbgObj.G, rbgObj.B);
    },
    convertRgbToNumber(r: number, g: number, b: number) {
        return (r << 24) + (g << 16) + (b << 8);
    },
    convertRgbaToNumber(r: number, g: number, b: number, a: number) {
        var R = r & 0xFF;
        var G = g & 0xFF;
        var B = b & 0xFF;
        var A = (a * 255) & 0xFF;
        return (R << 24) + (G << 16) + (B << 8) + (A);
    },
    convertArgbToNumber(r: number, g: number, b: number, a: number) {
        var R = r & 0xFF;
        var G = g & 0xFF;
        var B = b & 0xFF;
        var A = (a * 255) & 0xFF;
        return (A << 24) + (R << 16) + (G << 8) + (B << 0);
    },
    convertRgbToHex(r: number, g: number, b: number) {
        return `${this.colorCodeToHex(r)}${this.colorCodeToHex(g)}${this.colorCodeToHex(b)}`;
    },
    colorCodeToHex: function (num: number) {
        var hex = num.toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    },
}

export default ColorHelper;